import axios from 'axios';
import { getGapiBaseUrl } from '../config/config';

export default axios.create({
  baseURL: getGapiBaseUrl(),
});
